import React from "react";
import { useFormikContext } from "formik";
import styles from "./style.module.scss";
import Equipment from "./equipment";
const purchase = ["purchase_for"];
const monthly = ["rent_for", "lease_for", "monthly_fee"];

function Cost() {
  const { values } = useFormikContext();

  const calculateTotal = (type) => {
    if (!values?.equipments || !Array.isArray(values.equipments)) {
      return "0.00";
    }
    return values.equipments
      .filter((equipment) => type.includes(equipment.type))
      .reduce((total, equipment) => {
        const price = equipment[`${equipment.type}_default`] || 0;
        return total + parseFloat(price) * equipment.quantity;
      }, 0)
      .toFixed(2);
  };

  const calculateMonthlyTotal = () => {
    return values?.equipments
      ?.filter((equipment) => monthly.includes(equipment.type))
      .reduce((total, equipment) => {
        const price = equipment[`${equipment.type}_default`] || 0;
        return total + parseFloat(price) * equipment.quantity;
      }, 0)
      .toFixed(2);
  };

  const calculateSaasTotal = () => {
    return values?.equipments
      ?.filter((equipment) => equipment.sass_fee === 1)
      .reduce((total, equipment) => {
        const price = equipment.sass_fee_default || 0;
        return total + parseFloat(price) * equipment.quantity;
      }, 0)
      .toFixed(2);
  };

  return (
    <div className={styles.cost}>
      <h5 className={styles.head}>Cost of Hardware</h5>

      <div className={styles.cost_items}>
        <div className={styles.cost_item}>
          <h6 className={styles.cost_heading}>Purchases</h6>
          {values?.equipments && Array.isArray(values.equipments)
            ? values.equipments.map((e, i) => ({ e, i }))
            : []
                .filter(({ e }) => e.type === "purchase_for")
                .map(({ e, i }) => (
                  <Equipment
                    key={`${e.id}-purchase-${i}`}
                    equipment={e}
                    tag="buy"
                    index={i}
                  />
                ))}
          <div className={styles.cost_numbers}>
            <span className={styles.total}>Total Due Today</span>
            <span className={styles.price}>$ {calculateTotal(purchase)}</span>
          </div>
        </div>

        <div className={styles.cost_item}>
          <h6 className={styles.cost_heading}>Monthly Costs</h6>
          {values?.equipments && Array.isArray(values.equipments)
            ? values.equipments.map((e, i) => ({ e, i }))
            : []
                .filter(({ e }) => monthly.includes(e.type))
                .map(({ e, i }) => (
                  <Equipment
                    key={`${e.id}-monthly-${i}`}
                    equipment={e}
                    tag={
                      e.type === "rent_for"
                        ? "rent"
                        : e.type === "lease_for"
                          ? "lease"
                          : "monthly"
                    }
                    index={i}
                  />
                ))}

          {values?.equipments
            ?.filter((equipment) => equipment.sass_fee === 1)
            .map((equipment, index) => (
              <div
                key={`saas-fee-${equipment.id}-${index}`}
                className={styles.sass_fee_item}
              >
                <div className={styles.sass_fee_info}>
                  <span className={styles.sass_fee_name}>
                    SaaS fee for {equipment.equipment_name}
                  </span>
                  <span className={styles.sass_fee_price}>
                    ${" "}
                    {(
                      parseFloat(equipment.sass_fee_default || 0) *
                      equipment.quantity
                    ).toFixed(2)}
                  </span>
                </div>
              </div>
            ))}

          <div className={styles.cost_numbers}>
            <span className={styles.total}>Total Due Monthly</span>
            <span className={styles.price}>
              ${" "}
              {(
                parseFloat(calculateMonthlyTotal()) +
                parseFloat(calculateSaasTotal())
              ).toFixed(2)}
            </span>
          </div>
        </div>

        <div className={styles.cost_item}>
          <h6 className={styles.cost_heading}>TPP Hardware</h6>
          {values?.equipments
            ?.map((e, i) => ({ e, i }))
            .filter(({ e }) => e.type === "apply_tpp")
            .map(({ e, i }) => (
              <Equipment
                key={`${e.id}-tpp-${i}`}
                equipment={e}
                apply_tpp={true}
                tag="tpp"
                index={i}
              />
            ))}

          <div className={styles.cost_numbers}>
            <span className={styles.total}>Total</span>
            <span className={styles.price}>$0.00</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cost;
